import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { IFormElementProps } from '../FormElement/FormInput'

type C = React.ComponentType<IFormElementProps>

function withRedux(Component: C) {
  return function({
                    input,
                    meta,
                    ...rest
                  }: WrappedFieldProps & IFormElementProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        onFocus={input.onFocus}
        onBlur={input.onBlur}
        errorMsg={meta.error}
        warningMsg={meta.warning}
        isSelected={meta.active}
        isValidating={meta.asyncValidating}
        {...rest}
      />
    )
  }
}

export default withRedux
